import { render, staticRenderFns } from "./CompanyRegistrationSetting.vue?vue&type=template&id=69b979d7&scoped=true"
import script from "./CompanyRegistrationSetting.vue?vue&type=script&lang=js"
export * from "./CompanyRegistrationSetting.vue?vue&type=script&lang=js"
import style0 from "./CompanyRegistrationSetting.vue?vue&type=style&index=0&id=69b979d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b979d7",
  null
  
)

export default component.exports